import { API_ENDPOINTS } from "../../../Api/apiEndPoints"
import axiosInstance from "../../../Api/axiosInstance"

export const getTaConfigurationList = async(params={})=>{

    let response = await axiosInstance.get(API_ENDPOINTS.CONFIGURATION.GET_TA_CONFIGURATION,{params:params});
    const rowData = await response?.data;  

    const data = Array.isArray(response?.data?.data?.data)
    ?response.data.data.data.map((item:any)=>({
    
    FromKM: item.FromKm || "-",
    ToKM: item.ToKm || '-',
    PolicyKey:item.PolicyKey || "-",
    TaConfigId:item.TaConfigId || '-',
    CompanyId:item.CompanyId || '-'
    })):[] 
  return{rowData,data}
}

export const getPolicuKeyList = async()=>{
    let response = await axiosInstance.get(API_ENDPOINTS.CONFIGURATION.GET_POLICY_KEY_LIST);
    const rowData = await response?.data;
    const data = Object.entries(rowData?.data|| {}).map(([id,label]:[string,any])=>({
        id:label,
        label: String(label)
    }))
    return{data};
}

export const AddTAConfiguration = async (ReqBody:any)=>{
  const url =  `${API_ENDPOINTS.CONFIGURATION.POST_ADD_TA_CONFIGURATION}`
  let response =  await axiosInstance.post(url,ReqBody)
}


export const updatTAConfiguration = async(ReqBody:any,id:number | null)=>{
     const url = `${API_ENDPOINTS.CONFIGURATION.PUT_UPDATE_TA}/${id}`;
     let response = await axiosInstance.put(url,ReqBody); 
}